import { Subwerkcat } from "@/models/subwerkcat";
import { Reducer, createAction, createReducer } from "@reduxjs/toolkit";

export interface SubwerkcatsState {
    data: Subwerkcat[],
    loaded: boolean
}

const initialState: SubwerkcatsState = {
    data: [],
    loaded: false
}

const setDataAction = createAction<Subwerkcat[]>('subwerkcats/set-data')
const clearDataAction = createAction('subwerkcats/clear-data')

export const subwerkcatReducer = createReducer(
    initialState,
    (builder) => {
        builder.addCase(setDataAction, (state, action) => {
            state.data = action.payload;
            state.loaded = true;
        }).addCase(clearDataAction, (state, action) => {
            state.data = [];
            state.loaded = false;
        })
    }
)


export const subwerkcatActions = {
    set_data: setDataAction,
    clear_data: clearDataAction
}
